// Shell persistente: a sidebar de navegação fica montada uma única vez e só o
// conteúdo (Outlet) troca ao navegar. Elimina o "piscar" causado pela remontagem
// da sidebar a cada rota.
import React from 'react';
import { Outlet } from 'react-router-dom';
import ServiceSidebar from './ServiceSidebar';
import ErrorBoundary from './ErrorBoundary';
import { useGlobalAuth } from '../contexts/GlobalAuthContext';
import useNavigationItems from '../hooks/useNavigationItems';
import { SIDEBAR_SLOT_ID } from './SidebarPortal';

const AppShell: React.FC = () => {
  const { user } = useGlobalAuth();
  const navigationItems = useNavigationItems(user as any);

  return (
    <div className="service-layout">
      <ServiceSidebar
        serviceTitle=""
        serviceIcon=""
        userName={user?.name}
        userRole={user?.role}
        navigationItems={navigationItems}
      >
        {/* slot onde cada página injeta sua lista de projetos / ações */}
        <div id={SIDEBAR_SLOT_ID} />
      </ServiceSidebar>
      <div className="service-main-content">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default AppShell;
